'use strict';

import React from 'react';
import classnames from 'classnames';

import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import Misc from '../../definitions/Misc';
import { OTLink, OTNavLink } from '../tag/OTLink';
import Row from '../tag/Row';
import OTIcon from '../tag/OTIcon';

import { showHpaBeginModal, showHpaChangeModal } from '../../data/hpa/actions';
import Span from '../tag/Span';
import { selectIsHpa } from '../../data/hpa/selectors';
import SessionUtils from '../../utils/SessionUtils';
import DockBarButton from './DockbarButton';
import { getTime } from '../../utils/TimeUtils';
import { getNotificationCountWithoutBundled } from '../../utils/Functions';

import dockbarImgSrc from '../../images/control-panel-logo.png';
import dockbarImgSrcHpa from '../../images/control-panel-logo-white.png';

class DockBar extends React.Component {
  render() {
    const notificationCountMessageIdChoose = (
      desktopUserMenuNotificationCount
    ) => {
      return desktopUserMenuNotificationCount > 0
        ? desktopUserMenuNotificationCount === 1
          ? 'navigation.notificationDescForOne'
          : 'navigation.notificationDesc'
        : null;
    };

    let {
      intl,
      showHpaBeginModal,
      showHpaChangeModal,
      userInfo,
      toggleNavigation,
      isHpa,
      notifications,
      logoLink = null,
    } = this.props;

    let mobileMenuNotificationCount = 0,
      mobileUserMenuNotificationCount = 0,
      desktopUserMenuNotificationCount = 0,
      desktopUserMenuNotificationElement = null;

    if (notifications) {
      /* Count multiple omavointi questionnaires as one, because omavointi questionnaires are bundled */
      mobileMenuNotificationCount = Object.values(notifications).reduce(
        (acc, cur) =>
          acc +
          getNotificationCountWithoutBundled(cur, 'OmavointiQuestionnaire'),
        0
      );
    }

    if (userInfo) {
      if (
        getTime().isAfter(
          getTime(userInfo.userInfoTimestamp).add(
            ...Misc.contactReminderInterval()
          )
        )
      ) {
        mobileUserMenuNotificationCount++;
        desktopUserMenuNotificationCount++;
      }
      desktopUserMenuNotificationCount > 0 &&
        (desktopUserMenuNotificationElement = (
          <span
            className="ot-dockbar__notification"
            aria-label={
              desktopUserMenuNotificationCount +
              intl.formatMessage({
                id: notificationCountMessageIdChoose(
                  desktopUserMenuNotificationCount
                ),
              })
            }
          >
            {desktopUserMenuNotificationCount}
          </span>
        ));
    }

    let dockbarContainerClassnames = classnames(
      'ot-dockbarcontainer',
      'no-print-element',
      {
        'ot-dockbarcontainer--hpa': isHpa,
      }
    );

    let logoImage = (
      <img
        className="ot-dockbar__image"
        src={isHpa ? dockbarImgSrcHpa : dockbarImgSrc}
        alt={intl.formatMessage({ id: 'omatays.to.frontpage' })}
      />
    );

    return (
      <Row className={dockbarContainerClassnames}>
        <div className="ot-dockbar">
          <Row>
            <Span len="3" sm-len="3">
              {logoLink ? (
                <OTLink link={logoLink}>{logoImage}</OTLink>
              ) : (
                <>{logoImage}</>
              )}
            </Span>
            <Span len="9" sm-len="9">
              {userInfo && (
                <>
                  <Span len="8" sm-len="8" className="ot-dockbar__desktop">
                    <OTNavLink link={'/userinfo'} activeClassName="is-active">
                      <DockBarButton
                        type="default"
                        icon={
                          <OTIcon
                            config={{ type: 'custom', name: 'profiili' }}
                          />
                        }
                        action={() => {}}
                      >
                        {userInfo.wholeName}
                        {desktopUserMenuNotificationElement}
                      </DockBarButton>
                    </OTNavLink>
                  </Span>

                  <span className="ot-dockbar__mobile">
                    <button
                      onClick={() => {
                        if (isHpa) {
                          showHpaChangeModal();
                        } else {
                          showHpaBeginModal();
                        }
                      }}
                    >
                      <OTIcon
                        config={{
                          type: 'custom',
                          name: 'puolesta-asiointi',
                          color: isHpa ? 'white' : 'darkblue',
                        }}
                      />
                    </button>

                    <button onClick={() => toggleNavigation()}>
                      <OTIcon
                        config={{
                          type: 'fa',
                          name: 'icon-reorder',
                          color: isHpa ? 'white' : 'blue',
                        }}
                      >
                        {mobileMenuNotificationCount > 0 && (
                          <span className="ot-dockbar__mobile__notification">
                            {mobileMenuNotificationCount}
                          </span>
                        )}
                      </OTIcon>
                    </button>
                  </span>

                  <Span
                    len="4"
                    sm-len="4"
                    className="ot-dockbar__desktop__btn-group"
                  >
                    <DockBarButton
                      type={isHpa ? 'no-bg-hpa' : 'no-bg'}
                      icon={
                        <OTIcon
                          config={{
                            type: 'custom',
                            name: 'puolesta-asiointi',
                            color: isHpa ? 'white' : 'darkblue',
                          }}
                        />
                      }
                      action={() => {
                        if (isHpa) {
                          showHpaChangeModal();
                        } else {
                          showHpaBeginModal();
                        }
                      }}
                    >
                      <FormattedMessage
                        id={isHpa ? 'hpa.change' : 'hpa.begin'}
                      />
                    </DockBarButton>
                    <DockBarButton
                      type={isHpa ? 'no-bg-hpa' : 'no-bg'}
                      icon={
                        <OTIcon
                          aria-hidden="true"
                          config={{ type: 'fa', name: 'icon-signout' }}
                          className="ot-dropdown__item__column"
                        />
                      }
                      action={SessionUtils.logout}
                    >
                      <FormattedMessage id={'sign.out'} />
                    </DockBarButton>
                  </Span>
                </>
              )}
            </Span>
          </Row>
        </div>
      </Row>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isHpa: selectIsHpa(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    showHpaChangeModal: () => dispatch(showHpaChangeModal()),
    showHpaBeginModal: () => dispatch(showHpaBeginModal()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(DockBar));
